import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UpdateVidyoParticipantDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const muteParticipantVideo = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: UpdateVidyoParticipantDto;
}): Promise<void> => {
  await axiosClient.post<void, UpdateVidyoParticipantDto>(
    `sessions/${sessionId}/in-call/disable-video`,
    body,
  );
};

const unmuteParticipantVideo = async ({
  sessionId,
  body,
}: {
  sessionId: string;
  body: UpdateVidyoParticipantDto;
}): Promise<void> => {
  await axiosClient.post<void, UpdateVidyoParticipantDto>(
    `sessions/${sessionId}/in-call/enable-video`,
    body,
  );
};

function useMuteParticipantVideo(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { sessionId: string; body: UpdateVidyoParticipantDto }
  >,
) {
  return useMutation({
    mutationFn: muteParticipantVideo,
    ...mutationOptions,
  });
}

function useUnmuteParticipantVideo(
  mutationOptions?: UseMutationOptions<
    void,
    HttpError,
    { sessionId: string; body: UpdateVidyoParticipantDto }
  >,
) {
  return useMutation({
    mutationFn: unmuteParticipantVideo,
    ...mutationOptions,
  });
}

export { useMuteParticipantVideo, useUnmuteParticipantVideo };
